import React from 'react';
import './Contractjob.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';


const Textcoldescribe5 = () => {
    return(
        <>
        <Container>
            <Row className='textrow'>
                    <Col sm={12} className='textcol'>
                        <h4>Continuous Support</h4>
                        <p>You will always be a part of the Neutrosys family, and we will maintain constant communication
                        with you even after you land your dream job. Our dedication to our consultants has led to high
                        retention rates on multiple projects.</p>
                    </Col>
                </Row>
            </Container>
        </>
    )
} 

export default Textcoldescribe5